import {
  FETCH_LOGIN_ATTEMPTS,
  FETCH_LOGIN_ATTEMPTS_SUCCESS,
  FETCH_LOGIN_ATTEMPTS_ERROR,
  FETCH_BLOCKED_LIST,
  FETCH_BLOCKED_LIST_SUCCESS,
  FETCH_BLOCKED_LIST_ERROR,
  FETCH_LOGIN_STATS,
  FETCH_LOGIN_STATS_SUCCESS,
  FETCH_LOGIN_STATS_ERROR,
  UNBLOCK_IP,
  UNBLOCK_IP_SUCCESS,
  UNBLOCK_IP_ERROR,
  UNBLOCK_EMAIL,
  UNBLOCK_EMAIL_SUCCESS,
  UNBLOCK_EMAIL_ERROR,
  SET_FILTER
} from './types';

const INITIAL_STATE = {
  // Login attempts data
  attempts: [],
  pagination: {},
  filters: {
    blocked_only: false,
    failed_only: true,
    hours: 24,
    page: 1,
    limit: 50
  },
  
  // Blocked list data
  blockedIPs: [],
  blockedEmails: [],
  totalBlocked: 0,
  
  // Statistics
  stats: null,
  
  // Loading states
  loading: false,
  loadingBlocked: false,
  loadingStats: false,
  unblockingIP: false,
  unblockingEmail: false,
  
  // Error states
  error: null,
  blockedError: null,
  statsError: null,
  unblockError: null,
  
  // Last updated timestamps
  lastUpdated: null,
  blockedLastUpdated: null,
  statsLastUpdated: null
};

export default function loginAttemptsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Fetch login attempts
    case FETCH_LOGIN_ATTEMPTS:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_LOGIN_ATTEMPTS_SUCCESS:
      return {
        ...state,
        loading: false,
        attempts: action.payload.attempts || [],
        pagination: action.payload.pagination || {},
        filters: { ...state.filters, ...action.payload.filters },
        error: null,
        lastUpdated: new Date()
      };
    
    case FETCH_LOGIN_ATTEMPTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        attempts: [],
        pagination: {}
      };

    // Fetch blocked list
    case FETCH_BLOCKED_LIST:
      return {
        ...state,
        loadingBlocked: true,
        blockedError: null
      };
    
    case FETCH_BLOCKED_LIST_SUCCESS:
      return {
        ...state,
        loadingBlocked: false,
        blockedIPs: action.payload.blocked_ips || [],
        blockedEmails: action.payload.blocked_emails || [],
        totalBlocked: action.payload.total_blocked || 0,
        blockedError: null,
        blockedLastUpdated: new Date()
      };
    
    case FETCH_BLOCKED_LIST_ERROR:
      return {
        ...state,
        loadingBlocked: false,
        blockedError: action.payload,
        blockedIPs: [],
        blockedEmails: [],
        totalBlocked: 0
      };

    // Fetch login stats
    case FETCH_LOGIN_STATS:
      return {
        ...state,
        loadingStats: true,
        statsError: null
      };
    
    case FETCH_LOGIN_STATS_SUCCESS:
      return {
        ...state,
        loadingStats: false,
        stats: action.payload,
        statsError: null,
        statsLastUpdated: new Date()
      };
    
    case FETCH_LOGIN_STATS_ERROR:
      return {
        ...state,
        loadingStats: false,
        statsError: action.payload,
        stats: null
      };

    // Unblock IP
    case UNBLOCK_IP:
      return {
        ...state,
        unblockingIP: true,
        unblockError: null
      };
    
    case UNBLOCK_IP_SUCCESS:
      return {
        ...state,
        unblockingIP: false,
        unblockError: null,
        // Remove IP from blocked list
        blockedIPs: state.blockedIPs.filter(ip => ip.ip_address !== action.payload.ip_address),
        totalBlocked: Math.max(0, state.totalBlocked - 1)
      };
    
    case UNBLOCK_IP_ERROR:
      return {
        ...state,
        unblockingIP: false,
        unblockError: action.payload
      };

    // Unblock email
    case UNBLOCK_EMAIL:
      return {
        ...state,
        unblockingEmail: true,
        unblockError: null
      };
    
    case UNBLOCK_EMAIL_SUCCESS:
      return {
        ...state,
        unblockingEmail: false,
        unblockError: null,
        // Remove email from blocked list
        blockedEmails: state.blockedEmails.filter(email => email.email !== action.payload.email),
        totalBlocked: Math.max(0, state.totalBlocked - 1)
      };
    
    case UNBLOCK_EMAIL_ERROR:
      return {
        ...state,
        unblockingEmail: false,
        unblockError: action.payload
      };

    // Set filter
    case SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.filterName]: action.payload.filterValue,
          // Reset to page 1 when filters change
          page: action.payload.filterName !== 'page' ? 1 : state.filters.page
        }
      };

    default:
      return state;
  }
}